export const LIMIT = 50